const prefix = '@catalog';

export const RESET_GOOD = `${prefix}/RESET_GOOD`;
export const REMOVE_INGREDIENT = `${prefix}/REMOVE_INGREDIENT`;
export const CANCEL_REMOVED_INGREDIENTS = `${prefix}/CANCEL_REMOVED_INGREDIENTS`;
export const CHANGE_DOUGH = `${prefix}/CHANGE_DOUGH`;
export const CHANGE_SIZE = `${prefix}/CHANGE_SIZE`;
export const TOGGLE_STUFFED_CRUST = `${prefix}/TOGGLE_STUFFED_CRUST`;
export const SELECT_STUFFED_CRUST = `${prefix}/SELECT_STUFFED_CRUST`;

export const FETCH_GOODS_REQUEST = `${prefix}/FETCH_GOODS_REQUEST`;
export const FETCH_GOODS_SUCCESS = `${prefix}/FETCH_GOODS_SUCCESS`;
export const FETCH_GOODS_FAILURE = `${prefix}/FETCH_GOODS_FAILURE`;

export const FETCH_GOOD_REQUEST = `${prefix}/FETCH_GOOD_REQUEST`;
export const FETCH_GOOD_SUCCESS = `${prefix}/FETCH_GOOD_SUCCESS`;
export const FETCH_GOOD_FAILURE = `${prefix}/FETCH_GOOD_FAILURE`;

export const ADD_TO_CART_REQUEST = `${prefix}/ADD_TO_CART_REQUEST`;
export const ADD_TO_CART_SUCCESS = `${prefix}/ADD_TO_CART_SUCCESS`;
export const ADD_TO_CART_FAILURE = `${prefix}/ADD_TO_CART_FAILURE`;

export const FETCH_INGREDIENTS_REQUEST = `${prefix}/FETCH_INGREDIENTS_REQUEST`;
export const FETCH_INGREDIENTS_SUCCESS = `${prefix}/FETCH_INGREDIENTS_SUCCESS`;
export const FETCH_INGREDIENTS_FAILURE = `${prefix}/FETCH_INGREDIENTS_FAILURE`;

export const FETCH_PIZZAFILTER_REQUEST = `${prefix}/FETCH_PIZZAFILTER_REQUEST`;
export const FETCH_PIZZAFILTER_SUCCESS = `${prefix}/FETCH_PIZZAFILTER_SUCCESS`;
export const FETCH_PIZZAFILTER_FAILURE = `${prefix}/FETCH_PIZZAFILTER_FAILURE`;

export const FETCH_UPSALE_REQUEST = `${prefix}/FETCH_UPSALE_REQUEST`;
export const FETCH_UPSALE_SUCCESS = `${prefix}/FETCH_UPSALE_SUCCESS`;
export const FETCH_UPSALE_FAILURE = `${prefix}/FETCH_UPSALE_FAILURE`;
export const ADD_TO_CART_FROM_UPSALE = `${prefix}/ADD_TO_CART_FROM_UPSALE`;
